import { FINAL_CTA } from "../../data/content";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050B14] border-t border-white/10 py-12 md:py-16"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 items-end">
          <div className="col-span-12 md:col-span-6">
            <div className="font-serif-display text-white text-3xl md:text-4xl tracking-tight">
              Marie&thinsp;·&thinsp;Joseph
            </div>
            <div className="overline mt-3">
              Sunreef 80 Eco · Hull 01 · Founder-owned
            </div>
            <a
              href={FINAL_CTA.dossierUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-dossier-link"
              className="link-underline mt-6 inline-block text-[#E5D3B3] text-sm tracking-[0.18em] uppercase"
            >
              Full Dossier · PDF →
            </a>
          </div>
          <div className="col-span-12 md:col-span-6 md:text-right text-xs uppercase tracking-[0.2em] text-white/40 leading-loose">
            <div>Editorial sales dossier · Private circulation</div>
            <div className="mt-4 text-white/30">
              © {new Date().getFullYear()} — All imagery rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
